import { useState } from 'react'
import { cn } from '@/shared/lib/cn'
import { IconChevron, IconFile } from './ToolIcons'
import { TOOL_CONFIGS, SKIP_KEYS } from './toolConfigs'

interface ToolCallGroupProps {
  calls: Array<{ name: string; args: Record<string, unknown> }>
}

export function ToolCallGroup({ calls }: ToolCallGroupProps) {
  const [expanded, setExpanded] = useState(false)

  const formatValue = (value: unknown): string => {
    if (typeof value === 'string') return value
    if (typeof value === 'number' || typeof value === 'boolean') return String(value)
    return JSON.stringify(value, null, 2)
  }

  return (
    <div className="mb-2 rounded-lg border border-white/10 overflow-hidden">
      <button
        onClick={() => setExpanded(!expanded)}
        className="w-full flex items-center gap-1.5 px-2.5 py-1.5 text-xs text-white/40 hover:text-white/60 hover:bg-white/5 transition-colors"
      >
        <IconChevron className="w-3 h-3 flex-shrink-0" expanded={expanded} />
        <span>{calls.length} tool call{calls.length !== 1 ? 's' : ''}</span>
      </button>
      {expanded && (
        <div className="px-2.5 pb-1 border-t border-white/5 max-h-64 overflow-y-auto">
          {calls.map((call, idx) => {
            const config = TOOL_CONFIGS[call.name.toLowerCase()] ?? { Icon: IconFile, color: 'text-white/40' }
            const { Icon, color } = config
            const filteredArgs = Object.entries(call.args).filter(([key]) => !SKIP_KEYS.has(key))
            return (
              <div key={idx} className="flex gap-2.5 py-2 border-b border-white/5 last:border-0">
                <Icon className={cn('w-3.5 h-3.5 flex-shrink-0 mt-0.5', color)} />
                <div className="min-w-0 flex-1">
                  <span className="text-xs font-semibold text-white/75">{call.name}</span>
                  {filteredArgs.length > 0 && (
                    <div className="mt-1 space-y-0.5">
                      {filteredArgs.map(([key, value]) => (
                        <div key={key} className="text-xs font-mono leading-snug">
                          <span className="text-white/35">{key} </span>
                          <span className="text-white/65 break-all">{formatValue(value)}</span>
                        </div>
                      ))}
                    </div>
                  )}
                </div>
              </div>
            )
          })}
        </div>
      )}
    </div>
  )
}
